import React from 'react'
import { Link, Outlet } from 'react-router-dom'
// import { Cartlist } from './Cart'

export const Header = ({array}) => {
  return (
    <div >
      <div className='headerbox'>
        <nav class="navbar navbar-expand-lg navbar-light bg-light p-3">
          <div class="container-fluid">
            <a class="navbar-brand" href=""> <img src="./images/shoelogo.png" className='shoelogo' alt="" /> </a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
              <div class="navbar-nav mx-auto">
                <div className='d-flex'>
                  <a class="nav-link active" aria-current="page" href="#"><Link to="/" className='homealign'>Home</Link></a>
                  <a class="nav-link" href="#"><Link to="/about" className='homealign'>About</Link></a>
                  <a class="nav-link" href="#"><Link to="/product" className='homealign'>Product</Link></a>
                  <a class="nav-link" href="#"><Link to="/cart" className='homealign'>Cart ({array.length})</Link></a>
                </div>

                
              </div>
              <div className='d-flex justify-content-center'>
                  <input type="text" className='headrinput ' placeholder='Shoes' />
                 <a href="/Product"><button className='headerbtn'>Search</button></a> 
                </div>
            </div>
          </div>
        </nav>
        {/* <nav class="navbar navbar-expand-lg bg-body-tertiary">
  <div class="container-fluid">
    <a class="navbar-brand" href=""><img src="./images/shoelogo.png" className='shoelogo' alt="" /></a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mx-auto mb-2 mb-lg-0">
        <li class="nav-item">
        <a class="nav-link active" aria-current="page" href="#"><Link to="/" className='homealign'>Home</Link></a>
        </li>
        <li class="nav-item">
        <a class="nav-link" href="#"><Link to="/about" className='homealign'>About</Link></a>
        </li>
        <li class="nav-item">
        <a class="nav-link" href="#"><Link to="/product" className='homealign'>Product</Link></a>
        </li>
        <li class="nav-item">
        <a class="nav-link" href="#"><Link to="/cart" className='homealign'>Cart</Link></a>
        </li>
        
       
      </ul>
      <form class="d-flex" role="search">
        <input class="form-control me-2 headrinput" type="search" placeholder="Shoes" aria-label="Search"/>
        <button class="btn headerbtn" type="submit">Search</button>
      </form>
    </div>
  </div>
</nav> */}
      </div>
      <Outlet />

      {/* herosection */}

    </div>
  )
}
